export const blockIconsAudioandvideoMovieNew = (
	<span className='material-symbols-outlined'>movie</span>
);
